import React from 'react';

import { Box, ShimmerText, Text, VStack } from '@betterment/samba-react';

import { ExplanationHeading } from './ExplanationHeading';
import { RoundedBorderBox } from './RoundedBorderBox';

type ExplanationContentProps = { explanation: string | null; postExplanationDisclosure: string };
export const ExplanationContent: React.FC<ExplanationContentProps> = ({ explanation, postExplanationDisclosure }) => {
  const borderStyle = explanation ? 'gradientRotateOnce' : 'gradientRotateForever';
  return (
    <RoundedBorderBox borderStyle={borderStyle} style={{ width: '100%' }}>
      <VStack css={{ padding: 'space.200', gap: 'space.200', width: '100%' }}>
        <ExplanationHeading />
        {explanation ? (
          <>
            <Text variant="text50" color="text" dangerouslySetInnerHTML={{ __html: explanation }} />
            <Text variant="text25" color="text.weak" dangerouslySetInnerHTML={{ __html: postExplanationDisclosure }} />
          </>
        ) : (
          <VStack css={{ gap: 'space.100' }}>
            <ShimmerText textStyle="text50" />
            <ShimmerText textStyle="text50" />
            <Box css={{ width: '66%' }}>
              <ShimmerText textStyle="text50" />
            </Box>
          </VStack>
        )}
      </VStack>
    </RoundedBorderBox>
  );
};
